import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { PineLabsTimeOut } from 'src/app/common/enums/pinelabs.enum';
import { CurrencyService } from 'src/app/util/currency.service';
import { PINE_LAB_TIMEOUT } from 'src/defaultImages.js';

@Component({
  selector: 'app-time-out-popup',
  templateUrl: './time-out-popup.component.html',
  styleUrls: ['./time-out-popup.component.css'],
})
export class TimeOutPopupComponent implements OnInit {

  @Input() amount:number;  
  currency:string='';

  images = {
    PINE_LAB_TIMEOUT: PINE_LAB_TIMEOUT,
  };
  PineLabsTimeOut = PineLabsTimeOut;
  constructor(
    private _modalRef: NzModalRef,
    private _curr: CurrencyService,
  ) {
    this.currency = this._curr.getCurrency();
  }
  ngOnInit() {  }
  submit(val){
    this._modalRef.close(val);
  }
}
